import { useContext } from 'react';
import { OverlayContext } from '../../providers/OverlayContextProvider';
/**
 * Seagull-internal access to the managed sheet stack. Consumers outside seagull use the declarative
 * BottomSheet / surface props instead.
 *
 * @deprecated Imperative sheet-stack — being retired in favor of showModal (ANCR-3039 sheet-stack
 * retirement follow-up). Do not add new callers.
 */ export function useSheetStack() {
    return useContext(OverlayContext);
}
